import { css } from '@emotion/react'
import { useNavigate } from 'react-router'
import { Col, Content, Row, Title, Button, Icon } from 'common-components'
import { Space } from 'antd'

// TODO fix this
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Header = ({ data }) => {
  const navigate = useNavigate()
  const texts = [
    {
      type: 'tablePageTitle',
      content: 'Activité',
    },
    {
      type: 'tablePageSubtitle',
      content: 'Voici l’historique de votre activité',
    },
  ]

  return (
    // @ts-ignore
    <Content>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          margin: 24px 0;
        `}
      >
        <Col>
          <Row justify={'center'} gutter={30} align={'middle'}>
            <Col>
              <Button
                size='sm'
                onClick={() => {
                  navigate(-1)
                }}
              >
                <Icon icon='FlipBackward' />
              </Button>
            </Col>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space align={'center'}>
                      <Title key={`title-${text.content}-${index}`} style={{ fontSize: 18 }}>
                        {text.content}
                      </Title>
                    </Space>
                  )
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                )
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </Content>
  )
}

export default Header
